const isEmpty = value => {
    return value === null || value === '' || typeof value === undefined
}
export const buildQuery = data => {
    // If the data is already a string, return it as-is
    if (typeof data === 'string') return data
    // Create a query array to hold the key/value pairs
    return Object.keys(data).reduce((_qs, key) => {
        if (isEmpty(data[key])) return _qs
        const nv = `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        if (_qs) _qs += `&${nv}`
        else _qs = nv
        return _qs
    }, '')
}
